import { MessageCircle } from 'lucide-react';

export function FeedbackButton() {
  return (
    <a
      href="https://tally.so/r/Zj9NZv"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 px-4 py-3 rounded-full font-medium text-white transition-all duration-300 shadow-lg hover:shadow-xl"
      style={{
        backgroundColor: '#f97316',
        minHeight: '60px',
        boxShadow: '0 4px 12px rgba(249, 115, 22, 0.4)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#ea580c';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(234, 88, 12, 0.5)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#f97316';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(249, 115, 22, 0.4)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">Feedback</span>
    </a>
  );
}

